import { Injectable } from '@angular/core';
import { IFlightChecklist } from '@simplyfly/shared';
import { FirestoreService } from '../firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class FlightChecklistFirestoreService extends FirestoreService<IFlightChecklist> {
  protected basePath = 'flightChecklists';
}
